import {Game} from "./game/Game";

(() => {
    // const canvas = document.getElementById('app');
    // if (!(canvas instanceof HTMLCanvasElement)) throw new Error('Could not find canvas element');
    const game = new Game();
    let now = performance.now();
    requestAnimationFrame(update);
    function update(timestamp:number) {
        const delta_ms = timestamp - now;
        game.update(delta_ms / 1000);
        requestAnimationFrame(update);
    }
})();